import React, { useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
import { Btn, FormInput, SuccessComp } from "../../utils/utils";
import ReusableUpload from "../../utils/ReusableUpload";
import { AxiosAuthPost } from "../../api/api";
import { useNavigate } from "react-router-dom";

const AddEstate = () => {
  const navigate = useNavigate();
  const url = "developer/estates/";
  const [images, setImages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [msgSuc, setMsgSuc] = useState("");
  const [data, setData] = useState({
    name: "",
    city: "",
    state: "",
    pictures: [],
    postalCode: "",
    country: "",
  });
  const [dataErr, setDataErr] = useState({
    name: "",
    city: "",
    state: "",
    pictures: "",
    postalCode: "",
    country: "",
  });

  const dataChange = (e) => {
    const newData = { ...data };
    newData[e.target.id] = e.target.value;
    setData(newData);
    const newDataErr = { ...dataErr }; 
    newDataErr[e.target.id] = "";
    setDataErr(newDataErr);
    // console.log(newData);
  };

  const dataSet = {
    name: data.name,
    city: data.city,
    state: data.state,
    pictures: data.pictures,
    postalCode: data.postalCode,
    country: data.country,
  };

  const submitEstate = () => {
    setIsLoading(true);
    AxiosAuthPost(url, dataSet)
      .then((res) => {
        // console.log(res);
        setMsgSuc(res?.message);
        setIsLoading(false);
        setTimeout(() => {
          setMsgSuc("");
          navigate("/dev_dash/estate/estate-view");
        }, 2000);
        setData({
          name: "",
          city: "",
          state: "",
          pictures: [],
          postalCode: "",
          country: "",
        });
      })
      .catch((err) => {
        // console.log(err.response);
        for (let i = 0; i < err?.response?.data?.errors?.length; i++) {
          const fieldName = err?.response?.data?.errors[i].fieldName;
          const error = err?.response?.data?.errors[i].error;
          setDataErr((prevErrs) => ({
            ...prevErrs,
            [fieldName]: error,
          }));
        }
        setIsLoading(false);
      });
  };

  return (
    <div>
      <SuccessComp message={msgSuc} />
      <AgentHeader header={"Add Estate"} />
      <div className="estates_houses">
        <div className="estate_inp">
          <FormInput
            label={"Estate Name"}
            id={"name"}
            changeInput={dataChange}
            value={data.name}
            err={dataErr.name}
          />
          <div className="other_inp">
            <h3>Address</h3>
            <div className="oth_inp_inp">
              <FormInput
                label={"City"}
                inputStyle={{ width: "100%" }}
                id={"city"}
                changeInput={dataChange}
                value={data.city}
                err={dataErr.city}
              />
              <FormInput
                label={"State/Province"}
                inputStyle={{ width: "100%" }}
                id={"state"}
                changeInput={dataChange}
                value={data.state}
                err={dataErr.state}
              />
              <FormInput
                label={"Postal Code"}
                inputStyle={{ width: "100%" }}
                id={"postalCode"}
                changeInput={dataChange}
                value={data.postalCode}
                type={"number"}
                err={dataErr.postalCode}
              />
              <FormInput
                label={"Country"}
                inputStyle={{ width: "100%" }}
                id={"country"}
                changeInput={dataChange}
                value={data.country}
                err={dataErr.country}
              />
            </div>
          </div>
          <div className="other_inp">
            <h3>Pictures</h3>
            <ReusableUpload
              images={images}
              setData={setData}
              setImages={setImages}
              dataErr={dataErr}
              data={data}
            />
          </div>
          <div className="est_btn">
            <Btn
              btnText={"Cancel"}
              btnClass={"home-btn_trans-s"}
              btnClick={() => {
                navigate(-1);
              }}
            />
            <Btn
              btnText={"Save Estate"}
              btnClass={"home-btn_s"}
              btnClick={submitEstate}
              loading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEstate;
